import LocalizedStrings from "react-localization";

let idDictionary = {
  about: "Kilasan",
  about_event: "Tentang Event",
  all: "Semua",
  apply: "Terapkan",
  asset: "Menyimpan data lengkap aset penyimpanan vaksin",
  asset_data:
    "Menyimpan data terkini berbagai aset penyimpanan vaksin. Kondisi aset dapat selalu dipantau, dievaluasi, dan ditambah untuk menjamin kualitas vaksin.",
  browse_courses: "Kunjungi Kursus",
  bundle: "Paket",
  buy: "Beli",
  by: "Oleh",
  cannot: "Tidak boleh",
  catalog: "Katalog",
  certificate: "Sertifikat",
  chapter: "Bab",
  chat_dengan_admin: "Chat dengan Admin",
  column: "Kolom",
  contact_body:
    "Tim Help Desk SMILE siap melayani Anda sesuai kebutuhan. Berikut adalah nomor kontak Help Desk setiap daerah yang bisa dihubungi.",
  contact_person: "Kontak Penyelenggara",
  contact_us: "Kontak Kami",
  guide: "Panduan",
  coupon: "Kupon",
  course: "Kursus",
  course_catalog: "Katalog Kursus",
  course_intent:
    "Kursus ini ditujukan untuk tenaga kesehatan di tingkat provinsi, kabupaten/kota dan puskesmas. Dengan mengikuti kursus <i>online</i> ini, tenaga kesehatan akan dapat dengan mudah menggunakan SMILE untuk membantu tugasnya sehari-hari.",
  course_item: "Course",
  course_not_found: "Kursus tidak ditemukan",
  data_center:
    "Semua data terhubung dengan Pusat Data dan dapat ditarik secara otomatis untuk menyusun laporan. Tidak perlu lagi menyusun laporan secara manual.",
  distribution: "Memantau setiap saat distribusi vaksin",
  doses:
    "Mengetahui setiap saat status jumlah dosis vaksin yang tersedia, digunakan, direlokasi, dan yang kedaluwarsa atau rusak. Mencegah kekurangan atau kelebihan stok vaksin.",
  empty: "Kosong",
  enroll: "Daftar",
  enrolled: "Sudah Terdaftar",
  event: "Acara",
  event_not_found: "Acara tidak ditemukan",
  event_price: "Biaya Tiket",
  event_speaker: "Pengisi Acara",
  explore: "Jelajah",
  faq: "Tanya Jawab",
  filter: "Filter",
  finish: "Menyelesaikan",
  first: "Terlebih dahulu",
  for: "Untuk",
  free: "Gratis",
  free_course: "Course Gratis",
  home: "Kursus SMILE",
  important_notes: "Catatan Penting",
  inventory: "Mengelola dengan akurat inventaris vaksin",
  learning_path: "Syllabus",
  learning_path_not_found: "Program Belajar tidak ditemukan",
  lecture: "Materi",
  lecturer: "Pengajar",
  location: "Lokasi",
  login: "Masuk",
  logout: "Logout",
  monitoring_body:
    "Alat pengukur memantau ambang batas suhu dipenyimpanan vaksin dan mengirim sinyal bila suhu tempat pendingin melebihi ambang batas. Suhu vaksin selalu terjaga dalam batas normal",
  monitoring_title: "Memantau setiap saat suhu penyimpanan vaksin",
  must: "Harus",
  news: "Kabar SMILE",
  not_found: "Tidak Ditemukan",
  online_course: "Kursus Online Menggunakan SMILE",
  other_news: "Lihat kabar lainnya",
  paid_course: "Course Berbayar",
  previous: "sebelumnya {0}",
  price_range: "Rentang Harga",
  privacy_policy: "Rahasia Pribadi",
  profile: "Profil",
  publication: "Publikasi",
  rating: "Rating",
  register: "Daftar",
  registered: "Terdaftar",
  report: "Menyusun laporan berkala secara otomatis",
  reset: "Reset",
  result: "Hasil",
  review: "Ulasan",
  search_course_event: "Cari kursus atau event",
  search_result: "Hasil Pencarian",
  search_result_for: "Hasil pencarian untuk",
  see: "Lihat",
  see_all_events: "Lihat Semua Event",
  share:
    "Berbagai publikasi SMILE, dari buku pedoman, panduan, sampai video program dapat diakses publik disini",
  share_to: "Bagikan ke",
  smile_benefits: "Keunggulan SMILE",
  smile_training: "Pelatihan SMILE",
  submitted: "Mengirim",
  succesfully: "Berhasil",
  temperature: "Memantau setiap saat suhu penyimpanan vaksin",
  testi_1_content:
    "Dengan aplikasi SMILE, kita bisa memastikan logistik aman dan terjaga jumlahnya. Semoga aplikasi SMILE bisa segera diterapkan di seluruh Indonesia, sehingga bisa bermanfaat untuk kita semua.",
  testi_1_position: "Kepala Dinas Kesehatan Provinsi Gorontalo",
  testi_2_content:
    "SMILE sangat mempermudah pelaporan dan pencatatan vaksin, dari penerimaan, pemesanan, sampai pencatatan dan pelaporan ke dinas maupun ke Kemenkes. Dengan SMILE, kita tidak perlu lagi mencatat secara manual.",
  testi_2_position:
    "Apoteker Penanggung Jawab Logistik Vaksin Puskesmas Kecamatan Menteng, DKI Jakarta",
  time_place: "Waktu & Tempat",
  tracking:
    "Alat pelacak memastikan vaksin selalu tiba di tujuan dan diterima dalam jumlah yang sesuai dengan pesanan. Vaksin tiba tepat waktu sesuai pesanan.",
  training: "Pelatihan",
  training_docs: "Dokumentasi Pelatihan",
  type: "Jenis",
  vaccine:
    "Program imunisasi anak di Indonesia kini diperkuat oleh SMILE, sebuah aplikasi bagi tenaga kesehatan yang mencatat dan memantau pemesanan, distribusi, dan logistik vaksin secara <i>real-time</i>. Dikembangkan sejak 2018 oleh Kementerian Kesehatan RI dan UNDP, SMILE telah digunakan di berbagai fasilitas kesehatan dan secara bertahap hingga 2024 akan digunakan di seluruh fasilitas kesehatan, baik di tingkat pusat, provinsi, kabupaten, hingga puskesmas-puskesmas di pelosok Indonesia.",
  video_docs:
    "Dokumentasi video pelatihan SMILE sejak 2018 sebagai arsip dan pembelajaran di masa depan.",
  you: "Anda",
  youtube: "Kunjungi Channel Youtube Kami",
  instructor: "Instruktur",
  duration: "Durasi",
  minute: "Menit",
  number_chapter: "Jumlah Chapter",
  entity_type: "Tipe Entitas",
  program: "Program",
  access_info_course: "Kursus ini dapat diakses oleh SMILE Student dengan:",
  access_info_course_guest: "Guest student dapat mengakses kursus ini",
  male: "Laki - laki",
  female: "Perempuan",
};

let englishDictionary = {
  explore: "Explore",
  course: "Course",
  event: "Event",
  catalog: "Catalog",
  search_course_event: "Search course or event",
  course_catalog: "Course Catalog",
  search_result_for: "Search results for",
  course_not_found: "Course not found",
  event_not_found: "Event not found",
  learning_path_not_found: "Learning Path not found",
  see_all_events: "See all events",
  price_range: "Price Range",
  apply: "Apply",
  reset: "Reset",
  faq: "FAQ",
  privacy_policy: "Privacy Policy",
  chat_dengan_admin: "Chat dengan Admin",
  login: "Login",
  logout: "Logout",
  about_event: "About Event",
  event_speaker: "Event Speaker",
  event_price: "Event Price",
  time_place: "Time & Place",
  location: "Location",
  contact_us: "Contact Us",
  guide: "Panduan",
  contact_person: "Contact Person",
  important_notes: "Important Notes",
  about: "About",
  share_to: "Share to",
  enroll: "Enroll",
  publication: "Guidelines",
  vaccine: `The child immunization program in Indonesia is now being strengthened by SMILE, an application for healthcare professionals who are
	record and monitor ordering, distribution, and
	vaccine logistics in real-time. Developed since 2018
	by the Ministry of Health of the Republic of Indonesia and UNDP, SMILE has
	used in various health facilities and online
	increments until 2024 will be used throughout the facility
	health, at the central, provincial, district,
	to community health centers in remote areas of Indonesia.`,
  smile_benefits: "SMILE Benefits",
  inventory: "Manage vaccine inventory accurately",
  doses:
    "Know at all times the status of the number of vaccine doses that are available, used, relocated, and which are out of date or damaged. Prevent shortages or excess stocks of vaccines.",
  distribution: "Monitor vaccine distribution at all times",
  tracking:
    "The tracking device ensures vaccines always arrive at their destination and are received in the correct quantity ordered. Vaccines arrive on time as ordered.",
  temperature:
    "Alat pengukur memantau ambang batas suhu di alat penyimpanan vaksin dan mengirim sinyal bila suhu tempat pendingin melebihi ambang batas. Suhu vaksin selalu terjaga dalam batas normal.",
  asset: "Maintain complete data on vaccine storage assets",
  asset_data:
    "Maintain up-to-date data on vaccine storage assets. The condition of assets can always be monitored, evaluated, and improved to ensure the quality of vaccines.",
  report: "Automatically compile periodic reports",
  data_center:
    "All data is connected to the Data Center and can be pulled automatically to compile reports automatically. No more need to compile reports manually.",
  monitoring_title: "Monitor vaccine storage temperature at all times",
  monitoring_body:
    "The gauge monitors the temperature threshold of the vaccine storage and sends a signal when the cooler temperature exceeds the threshold. The temperature of the vaccine is always kept within normal limits.",
  share:
    "Our guidelines to understanding more about the SMILE application and its usage to solve challenges within health supply chain can be found here.",
  online_course: "Online Courses using SMILE",
  course_intent:
    "This course is intended for health workers at the provincial, district/city and puskesmas levels. By taking this online course, health workers will be able to easily use SMILE to help with their daily tasks.",
  training: "Training",
  training_docs: "Training Documentation",
  video_docs:
    "Documentation of SMILE training videos since 2018 as archives and future lessons.",
  youtube: "Visit Our Youtube Channel",
  instructor: "Instructor",
  duration: "Duration",
  minute: "Minute",
  number_chapter: "Number of Chapter",
  entity_type: "Entity Type",
  program: "Program",
  access_info_course: "This course can be accessed by SMILE Students with:",
  access_info_course_guest: "Guest students can access this course",
  news: "SMILE News",
  other_news: "See other news",
  contact_body:
    "The SMILE Help Desk team is ready to serve you as needed. The following are the contact numbers for the Help Desk for each area that can be reached",
  testi_1_content:
    "With the SMILE application we can ensure that the logistics are safe and the numbers are maintained. Hopefully the SMILE application can be immediately applied throughout Indonesia, so that it can be useful for all of us",
  testi_1_position: "Head of Gorontalo Provincial Health Office",
  testi_2_content:
    "The SMILE application makes it very easy to report as well as record vaccines, starting from receiving, ordering, recording and reporting it to the Ministry of Health. With this system, we no longer need to take notes manually, we only need to use the Smile application.",
  testi_2_position:
    "Pharmacist Responsible for Vaccine Logistics at the Menteng District Health Center, Jakarta",
  browse_courses: "Browse Courses",
  home: "Courses",
  smile_training: "SMILE Training",
  profile: "Profile",
  male: "Laki - laki",
  female: "Perempuan",
};

let alertIdDictionary = {
  invalid_coupon: "Kupon tidak valid atau sudah habis",
  chapter_not_finished: "",
  invalid_pin_digit: "PIN harus terdiri dari 6 digit angka",
  rating_not_valid: "Kolom rating tidak boleh ada yang kosong",
};

export const trans = new LocalizedStrings({
  id: idDictionary,
  en: englishDictionary,
});

export const alert = new LocalizedStrings({
  id: alertIdDictionary,
});



// WEBPACK FOOTER //
// ./src/components/Lang.js